import React, { useState } from 'react';
import axios from 'axios';

const URLManagerPage = () => {
  const [url, setUrl] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [alertType, setAlertType] = useState('');
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlertMessage('');
    
    // Basic validation
    if (!url) {
      setAlertMessage('Please enter a URL');
      setAlertType('error');
      return;
    }

    try {
      // Ensure URL has https:// prefix
      let cleanUrl = url.trim();
      if (!cleanUrl.startsWith('http://') && !cleanUrl.startsWith('https://')) {
        cleanUrl = 'https://' + cleanUrl;
      }

      const token = localStorage.getItem('authToken');
      const response = await axios.post(
        `${API_URL}/api/urls/add`,
        { url: cleanUrl },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setAlertMessage('URL added successfully!');
      setAlertType('success');
      setUrl('');
    } catch (error) {
      if (error.response && error.response.status === 409) {
        setAlertMessage('This URL already exists in the database.');
      } else {
        setAlertMessage('Error adding URL: ' + (error.response?.data?.message || error.message));
      }
      setAlertType('error');
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">URL Manager</h1>
      
      {alertMessage && (
        <div className={`p-4 mb-4 rounded-md ${alertType === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
          {alertMessage}
        </div>
      )}
      
      <div className="bg-white shadow-md rounded-lg p-6">
        <h2 className="text-xl font-semibold mb-4">Add URL to Queue</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="url" className="block text-sm font-medium text-gray-700 mb-1">
              URL
            </label>
            <input
              type="text"
              id="url"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter URL (e.g., example.org)"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
            <p className="text-sm text-gray-500 mt-1">
              URL will be automatically cleaned and added to the queue for processing.
            </p>
          </div>
          
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Add URL
          </button>
        </form>
      </div>
    </div>
  );
};

export default URLManagerPage;